import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const ColoredBarGraph = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  const setLid = (lid) => {
    alert(lid);
    props.changeLid(lid);
  };

  useEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.XYChart
    );
    if (props.data) {
      //title
      var title = x.titles.create();
      title.text = props.title;
      title.fontSize = 20;
      title.marginBottom = 30;
      title.fontWeight = 600;
      title.fill = "lightgrey";

      // x.dateFormatter.inputDateFormat = "yyyy-MM-dd";
      x.data = props.data;
      // Create axes
      // var dateAxis = x.xAxes.push(new am4charts.DateAxis());
      var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize = 11;
      valueAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      valueAxis.renderer.line.strokeOpacity = 0.2;
      valueAxis.renderer.line.strokeWidth = 1;
      valueAxis.renderer.line.stroke = am4core.color("#000");
      // valueAxis.title.text = "Actual";

      /* Create axes */
      var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props.category
        ? props.category
        : "time";
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.fontSize = 11;
      categoryAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.line.stroke = am4core.color("#95a5a6");
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.tooltip.disabled = true;
      categoryAxis.renderer.minHeight = 110;

      /* Create series */
      let columnSeries = x.series.push(new am4charts.ColumnSeries());
      columnSeries.sequencedInterpolation = true;
      columnSeries.yAxis = valueAxis;
      columnSeries.dataFields.valueY = props.barkey ? props.barkey : "actual";
      columnSeries.dataFields.categoryX = props.category
        ? props.category
        : "time";
      columnSeries.name = props.barkey ? props.barkey : "actual";
      // columnSeries.columns.template.width = am4core.percent(40);

      columnSeries.columns.template.tooltipText =
        "{categoryX}: [bold]{valueY}[/]";
      columnSeries.tooltip.pointerOrientation = "vertical";
      columnSeries.columns.template.fillOpacity = 0.8;
      columnSeries.columns.template.strokeOpacity = 0;
      // columnSeries.columns.template.fill = (props.barColor) ? am4core.color(props.barColor) : "color";
      columnSeries.columns.template.fontSize = 11;
      // columnSeries.columns.realStroke = (props.barColor) ? am4core.color(props.barColor) : "color";

      columnSeries.columns.template.column.cornerRadiusTopLeft = 10;
      columnSeries.columns.template.column.cornerRadiusTopRight = 10;

      // columnSeries.columns.template.events.enable();

      columnSeries.columns.template.events.on(
        "hit",
        function (ev) {
          // console.log(
          //   ev.target["dataItem"]["categories"]["categoryX"],
          //   props.data
          // );
          
          if(props.changeLid){
            props.changeLid(ev.target.dataItem.categories.categoryX);
          }
          // props.data.forEach((data, index) => {
          //   if (
          //     data["_id"] === ev.target["dataItem"]["categories"]["categoryX"]
          //   ) {
          //     console.log(data["lid"]);
          //     if (props.changeLid) {
          //       setLid(data["lid"]);
          //     }
          //   }
          // });
        },
        this
      );

      // on hover, make corner radiuses bigger
      var hoverState =
        columnSeries.columns.template.column.states.create("hover");
      // hoverState.properties.cornerRadiusTopLeft = 0;
      // hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      columnSeries.columns.template.adapter.add(
        "fill",
        function (fill, target) {
          return x.colors.getIndex(target.dataItem.index);
        }
      );

      // x.background.fill = am4core.color("#2F3640");

      x.scrollbarX = new am4core.Scrollbar();
      x.scrollbarX.background.fill = am4core.color("#515151");
      x.scrollbarX.thumb.background.fill = am4core.color("#515151");
      x.scrollbarX.startGrip.background.fill = am4core.color("#515151");
      x.scrollbarX.endGrip.background.fill = am4core.color("#515151");
      x.scrollbarX.stroke = am4core.color("#515151");
      x.scrollbarX.thumb.background.states.getKey('hover').properties.fill = am4core.color("#515151");
      x.scrollbarX.background.strokeOpacity = 0;
      x.scrollbarX.thumb.background.strokeOpacity = 0;
      x.scrollbarX.startGrip.background.strokeOpacity = 0;
      x.scrollbarX.endGrip.background.strokeOpacity = 0;
      // Add cursor
      x.cursor = new am4charts.XYCursor();

      // Cursor
      // x.cursor = new am4charts.XYCursor();

      chart.current = x;
    }

    return () => {
      // x.dispose();
    };
  });

  return (
    <div>
      {/* <div id={(props.divId) ? props.divId : "DivID"} style={{ width: "100%", height: "330px" }}></div> */}
      {props.data ? (
        <div
          id={props.divId ? props.divId : "DivID"}
          style={{
            width: "96%",
            height: "330px",
            padding: "10px",
            margin: "20px",
            boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
            borderRadius: "10px",
          }}
        ></div>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} />
        </div>
      )}
    </div>
  );
};

export default ColoredBarGraph;
